/**
 * Ploufe — eigen cookiebanner.
 * Stuurt de echte Shopify Customer Privacy API aan
 * (window.Shopify.customerPrivacy.setTrackingConsent) bij elke keuze — dat
 * is en blijft de bron van waarheid voor de daadwerkelijke toestemming.
 *
 * De keuze wordt daarnaast 12 maanden onthouden in localStorage en in een
 * cookie (lan_cookie_choice), zodat de banner maar een keer verschijnt.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'ploufe_cookie_choice_made';

  var root;
  var mainView;
  var settingsView;
  var settingsToggleBtn;
  var analyticsInput;
  var marketingInput;

  function qs(selector, context) {
    return (context || document).querySelector(selector);
  }

  function qsa(selector, context) {
    return Array.prototype.slice.call((context || document).querySelectorAll(selector));
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  // Keuze staat in localStorage (met tijdstempel) en in een cookie op het
  // hele domein. De cookie blijft ook staan bij geprerenderde pagina's en
  // wanneer localStorage leeg is.
  var COOKIE_NAME = 'lan_cookie_choice';
  var MAX_AGE_S = 365 * 24 * 60 * 60; // 12 maanden

  function readCookieChoice() {
    var match = document.cookie.match(new RegExp('(?:^|; )' + COOKIE_NAME + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function readLocalChoice() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      if (raw === '1') return 'legacy'; // oude opslag, van voor 2026-09-30
      var data = JSON.parse(raw);
      if (!data || !data.c || Date.now() - data.t > MAX_AGE_S * 1000) return null;
      return data.c;
    } catch (error) {
      return null;
    }
  }

  function storedChoice() {
    return readCookieChoice() || readLocalChoice();
  }

  function markChoiceStored(choice) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ c: choice, t: Date.now() }));
    } catch (error) {
      // Geen localStorage: de cookie hieronder is genoeg.
    }
    var secure = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie =
      COOKIE_NAME + '=' + encodeURIComponent(choice) + '; path=/; max-age=' + MAX_AGE_S + '; SameSite=Lax' + secure;
  }

  function choiceToConsent(choice) {
    if (choice === 'all') return { analytics: true, marketing: true, preferences: true, sale_of_data: true };
    if (choice === 'necessary') return { analytics: false, marketing: false, preferences: false, sale_of_data: false };
    var m = /^a([01])m([01])$/.exec(choice || '');
    if (!m) return null;
    return { analytics: m[1] === '1', marketing: m[2] === '1', preferences: m[1] === '1', sale_of_data: m[2] === '1' };
  }

  function consentToChoice(consent) {
    return 'a' + (consent.analytics === 'yes' ? 1 : 0) + 'm' + (consent.marketing === 'yes' ? 1 : 0);
  }

  // Heeft Shopify zelf al een keuze voor deze bezoeker? ('' = nog niets gekozen)
  function shopifyHasChoice(privacyApi) {
    if (typeof privacyApi.currentVisitorConsent !== 'function') return false;
    var consent = privacyApi.currentVisitorConsent() || {};
    return ['marketing', 'analytics', 'preferences', 'sale_of_data'].some(function (key) {
      return consent[key] === 'yes' || consent[key] === 'no';
    });
  }

  /**
   * Zorgt dat window.Shopify.customerPrivacy bestaat voordat callback draait.
   * content_for_header injecteert die API normaal automatisch, maar zodra er
   * in Admin → Customer privacy geen banner/regio meer geconfigureerd staat,
   * laadt Shopify het script kennelijk niet meer vanzelf — vandaar expliciet
   * window.Shopify.loadFeatures aanroepen (de door Shopify gedocumenteerde
   * manier om de Customer Privacy API zelf te laden), met een korte poll als
   * laatste redmiddel. Nooit direct falen: elke tak probeert het opnieuw.
   */
  function withPrivacyApi(callback) {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      callback(window.Shopify.customerPrivacy);
      return;
    }
    waitForShopifyGlobal(function () {
      if (window.Shopify.customerPrivacy) {
        callback(window.Shopify.customerPrivacy);
        return;
      }
      if (typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures(
          [{ name: 'consent-tracking-api', version: '0.1' }],
          function (error) {
            if (!error && window.Shopify.customerPrivacy) {
              callback(window.Shopify.customerPrivacy);
              return;
            }
            pollForPrivacyApi(callback);
          }
        );
        return;
      }
      pollForPrivacyApi(callback);
    });
  }

  function waitForShopifyGlobal(next, attemptsLeft) {
    attemptsLeft = typeof attemptsLeft === 'number' ? attemptsLeft : 50;
    if (window.Shopify) {
      next();
      return;
    }
    if (attemptsLeft <= 0) return;
    window.setTimeout(function () {
      waitForShopifyGlobal(next, attemptsLeft - 1);
    }, 100);
  }

  function pollForPrivacyApi(callback, attemptsLeft) {
    attemptsLeft = typeof attemptsLeft === 'number' ? attemptsLeft : 50;
    if (window.Shopify && window.Shopify.customerPrivacy) {
      callback(window.Shopify.customerPrivacy);
      return;
    }
    if (attemptsLeft <= 0) return;
    window.setTimeout(function () {
      pollForPrivacyApi(callback, attemptsLeft - 1);
    }, 100);
  }

  function setView(view) {
    var isSettings = view === 'settings';
    mainView.hidden = isSettings;
    settingsView.hidden = !isSettings;
    if (settingsToggleBtn) {
      settingsToggleBtn.setAttribute('aria-expanded', String(isSettings));
    }
    if (isSettings) syncTogglesWithConsent();
  }

  function syncTogglesWithConsent() {
    withPrivacyApi(function (privacyApi) {
      if (typeof privacyApi.currentVisitorConsent !== 'function') return;
      var consent = privacyApi.currentVisitorConsent();
      if (analyticsInput) analyticsInput.checked = consent.analytics === 'yes';
      if (marketingInput) marketingInput.checked = consent.marketing === 'yes';
    });
  }

  var earlyHandled = false;
  var SHOW_DELAY_MS = 600; // "komt na 600ms binnen, translateY 16px -> 0"
  var CHOOSE_ANIM_MS = 340; // bolletje halve slag + paneel vervaagt, zie {% style %} [data-state='choosing']

  function showBanner(view) {
    if (!root) return;
    // Al getoond door het inline script in de snippet: alleen de weergave
    // kiezen, niet opnieuw verbergen en na 600ms laten inkomen.
    if (!earlyHandled && root.hasAttribute('data-early')) {
      earlyHandled = true;
      setView(view || 'main');
      return;
    }
    root.hidden = false;
    root.setAttribute('data-state', 'hidden'); // startstand (opacity 0, translateY 16px), nog niet 'visible'
    setView(view || 'main');
    window.setTimeout(function () {
      root.setAttribute('data-state', 'visible');
      window.requestAnimationFrame(function () {
        root.focus();
      });
    }, SHOW_DELAY_MS);
  }

  function hideBanner() {
    if (!root) return;
    // Bij een keuze: bolletje een halve slag, paneel vervaagt (CSS
    // [data-state='choosing']) — dan pas echt verbergen.
    root.setAttribute('data-state', 'choosing');
    window.setTimeout(function () {
      root.hidden = true;
      root.setAttribute('data-state', 'hidden');
    }, CHOOSE_ANIM_MS);
  }

  function sendConsent(consentObj) {
    withPrivacyApi(function (privacyApi) {
      privacyApi.setTrackingConsent(consentObj, function (result) {
        if (result && result.error) {
          console.warn('Lanificio cookiebanner: toestemming niet opgeslagen bij Shopify', result.error);
        }
      });
    });
  }

  // De keuze wordt meteen onthouden en de banner verdwijnt meteen; Shopify
  // krijgt hem daarna (de API kan even nodig hebben om te laden).
  // Marketingpixels van Shopify wachten op deze toestemming.
  function applyChoice(choice) {
    markChoiceStored(choice);
    hideBanner();
    sendConsent(choiceToConsent(choice));
  }

  function acceptAll() {
    applyChoice('all');
  }

  function rejectAll() {
    applyChoice('necessary');
  }

  function saveSettings() {
    var analytics = !!(analyticsInput && analyticsInput.checked);
    var marketing = !!(marketingInput && marketingInput.checked);
    applyChoice('a' + (analytics ? 1 : 0) + 'm' + (marketing ? 1 : 0));
  }

  // Let op: shouldShowBanner() zegt alleen dat de regio (NL/EU) een banner
  // vereist, niet dat er nog geen keuze is. Die gaf voor NL altijd true, ook
  // na een keuze, waardoor de banner op elke pagina terugkwam. Daarom
  // bepalen onze eigen opslag en currentVisitorConsent() of hij komt.
  function initBannerVisibility() {
    var choice = storedChoice();
    if (!choice) {
      showBanner('main');
      withPrivacyApi(function (privacyApi) {
        // Keuze al bekend bij Shopify (gemaakt voor deze opslag bestond)?
        if (shopifyHasChoice(privacyApi) && root && !root.hidden) {
          markChoiceStored(consentToChoice(privacyApi.currentVisitorConsent()));
          root.hidden = true;
          root.setAttribute('data-state', 'hidden');
        }
      });
      return;
    }

    withPrivacyApi(function (privacyApi) {
      if (shopifyHasChoice(privacyApi)) {
        if (choice === 'legacy') markChoiceStored(consentToChoice(privacyApi.currentVisitorConsent()));
        return;
      }
      // Wel een keuze bij ons, maar Shopify is hem kwijt (cookie verlopen of
      // gewist): stil opnieuw doorgeven, zonder banner.
      var consent = choiceToConsent(choice);
      if (consent) sendConsent(consent);
      else showBanner('main'); // oude opslag zonder bekende keuze: opnieuw vragen
    });
  }

  ready(function () {
    root = document.getElementById('ploufe-cookie-banner');
    if (!root) return;

    mainView = qs('[data-cb-view="main"]', root);
    settingsView = qs('[data-cb-view="settings"]', root);
    settingsToggleBtn = qs('[data-cb-action="open-settings"]', root);
    analyticsInput = qs('[data-cb-toggle="analytics"]', root);
    marketingInput = qs('[data-cb-toggle="marketing"]', root);

    root.addEventListener('click', function (event) {
      var target = event.target.closest('[data-cb-action]');
      if (!target) return;
      var action = target.getAttribute('data-cb-action');
      if (action === 'accept-all') acceptAll();
      else if (action === 'reject-all') rejectAll();
      else if (action === 'open-settings') setView('settings');
      else if (action === 'save-settings') saveSettings();
    });

    // Weg klikken zonder keuze mag niet gelden als toestemming: Escape doet niets.
    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.stopPropagation();
      }
    });

    // Footer-link "Cookie-instellingen" opent de banner altijd opnieuw, ook
    // als er al een keuze is opgeslagen — negeert hasStoredChoice() bewust.
    qsa('[data-cb-open-settings]').forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        showBanner('settings');
      });
    });

    // Houdt de instellingen-toggles in sync als de toestemming ergens anders
    // verandert (bijv. een andere tab) terwijl het paneel openstaat.
    document.addEventListener('visitorConsentCollected', function () {
      if (settingsView && !settingsView.hidden) syncTogglesWithConsent();
    });

    initBannerVisibility();
  });
})();
